import { TransformToDays } from "@/utils/Functions/Functionts";
import "./PointsStory.scss";
import { format } from "date-fns";

interface PointsStoryPropsI {
  point: any;
}

function PointsStory(props: PointsStoryPropsI) {
  const { point } = props;
  const today = new Date();
  const todayInMS = today.getTime();
  const returnName = () => {
    if (point.reason === "Referral-parent") {
      return "Referral";
    }
    return point.content_name || point.reason;
  };
  return (
    <div className="point-main-container">
      <h3>
        {point.points} Point - {format(new Date(point.date), "MMM d, yyyy, p")}
      </h3>
      <div className="point-info-container">
        <div className="info">
          <h4 className="font-bold">Content:</h4>
          <p className="font-light">
            {returnName()}
            {point.status &&
              (point.status === "confirmed" || point.status === "removed") &&
              ` - ${point.status}`}
            {point.status && point.status === "not-granted" && " - pending"}
          </p>
        </div>
        <div className="info">
          <h4 className="font-bold">Total:</h4>
          <p className="font-light text-center">{point.total}</p>
        </div>
      </div>
    </div>
  );
}

export default PointsStory;
